import { HELP_CONTACT_EMAIL, buildHelpMailto } from '../lib/contactMailto';
import type { HelpMessage } from '../lib/types';

export interface ContactUsBarProps {
  /** Goes into the subject: `DVA help: <context>`. */
  contextLabel: string;
  /** The last few are quoted into the body as plain text. */
  messages: HelpMessage[];
  email?: string;
  quoteCount?: number;
}

/** Escalation as one quiet line: "Still stuck? Contact us", mailto on the bold text. No form, by decision. */
export function ContactUsBar({ contextLabel, messages, email = HELP_CONTACT_EMAIL, quoteCount = 4 }: ContactUsBarProps) {
  const href = buildHelpMailto({ email, contextLabel, messages, quoteCount });

  return (
    <div className="flex h-[52px] shrink-0 items-center gap-[5px] border-t border-[#e5e7eb] px-4 xl:h-auto xl:px-5 xl:py-3">
      <span className="text-[13px] text-[#717182] xl:text-[12.5px]">Still stuck?</span>
      <a
        href={href}
        className="flex h-11 items-center text-[13px] font-bold text-dvaNavy no-underline focus-visible:rounded focus-visible:ring-[3px] focus-visible:ring-dvaOrange/35 focus-visible:outline-none xl:h-auto xl:text-[12.5px]"
      >
        <span className="border-b border-dvaNavy pb-px hover:border-dvaOrange">Contact us</span>
      </a>
    </div>
  );
}
